import styled from "styled-components";
import { TitleH3 } from "ui";

export const StyledClientsQuote = styled(TitleH3)`
    font-weight: normal !important;
    text-align: center;
`